export default "__VITE_ASSET__3e6abb95__"